import { ColumnDef } from "@tanstack/react-table";
import { Link } from "@heroui/link";

import { parseDate } from "@/lib/utils";

export type FoBankContact = {
  id: number;
  client: string | null;
  sub_client: string | null;
  company_id: number;
  company_name: string | null;
  contact: string | null;
  contact_type: string | null;
  description: string | null;
  create_time: string;
  update_time: string;
};

type TFunc = (key: string) => string;

const contactTypeLabels: Record<string, string> = {
  it_support: "IT support",
  private_banker: "Private banker",
};

export const getFoBankContactColumns = (t: TFunc): ColumnDef<FoBankContact>[] => [
  {
    accessorKey: "id",
    header: t("fo_bank_contact.columns.id"),
  },
  {
    accessorKey: "client",
    header: t("fo_bank_contact.columns.client"),
  },
  {
    accessorKey: "sub_client",
    header: t("fo_bank_contact.columns.sub_client"),
  },
  {
    accessorKey: "company_name",
    header: t("fo_bank_contact.columns.company_name"),
  },
  {
    accessorKey: "contact",
    header: t("fo_bank_contact.columns.contact"),
  },
  {
    accessorKey: "contact_type",
    header: t("fo_bank_contact.columns.contact_type"),
    cell: ({ row }) => {
      const value = row.getValue("contact_type") as string | null;
      return value ? (contactTypeLabels[value] ?? value) : "";
    },
  },
  {
    accessorKey: "description",
    header: t("fo_bank_contact.columns.description"),
  },
  {
    accessorKey: "create_time",
    header: t("fo_bank_contact.columns.create_time"),
    cell: ({ row }) => parseDate(row.getValue("create_time")),
  },
  {
    accessorKey: "update_time",
    header: t("fo_bank_contact.columns.update_time"),
    cell: ({ row }) => parseDate(row.getValue("update_time")),
  },
  {
    id: "actions",
    header: () => <div className="text-right">{t("fo_bank_contact.columns.actions")}</div>,
    cell: ({ row }) => (
      <div className="flex justify-end">
        <Link
          href={`${window.location.pathname}/${row.original.id}`}
          className="text-xs"
          underline="hover"
        >
          {t("actions.edit")}
        </Link>
      </div>
    ),
  },
];
